export default "__VITE_ASSET__GoDPH2uy__"